import styled from 'styled-components'

const InputGroupUi = styled.div`
  position: relative;
  height: 42px;
`

export default InputGroupUi
